import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import AdmissionMarquee from './components/AdmissionMarquee';
import Features from './components/Features';
import Stats from './components/Stats';
import Talent from './components/Talent';
import Classes from './components/Classes';
import Innovations from './components/Innovations';
import SchoolsInAbuja from './components/SchoolsInAbuja';
import CTA from './components/CTA';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import LiveChat from './components/LiveChat';
import PageLoader from './components/PageLoader';
import ScrollProgress from './components/ScrollProgress';
import EnrolmentForm from './components/EnrolmentForm';
import { EnrolmentModalProvider } from './context/EnrolmentModalContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import ApplyPage from './pages/ApplyPage';

function MainSite() {
  return (
    <div className="App">
      <PageLoader />
      <ScrollProgress />
      <Header />
      <main>
        <Hero />
        <AdmissionMarquee />
        <Features />
        <Stats />
        <Talent />
        <Classes />
        <Innovations />
        <SchoolsInAbuja />
        <CTA />
        <Testimonials />
      </main>
      <Footer />
      <LiveChat />
      <EnrolmentForm />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <EnrolmentModalProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainSite />} />
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/apply" element={<ApplyPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </EnrolmentModalProvider>
    </AuthProvider>
  );
}

export default App;
